import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import { SecondsInDaysPipe } from '@recruitee/time';
import type { IconToken } from '@recruitee/user-interface';
import { DropdownItemComponent, IconComponent, RtTooltip } from '@recruitee/user-interface';

@Component({
  selector: 'rt-stage-item',
  templateUrl: './stage-item.component.html',
  styleUrls: ['./stage-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DropdownItemComponent, IconComponent, RtTooltip, SecondsInDaysPipe, TranslatePipe],
})
export class StageItemComponent {
  @Input() public title: string;
  @Input() public description?: string;
  @Input() public clickable = true;
  @Input() public disabled = false;
  @Input() public hasAutomatedActions: boolean;
  @Input() public timeLimit: number | null;
  @Input() public unbiasedHiringEnabled: boolean;
  @Input() public isCurrent: boolean = false;
  @Input() public showHiredIcon: boolean = false;
  @Input() public tooltipCopy?: string;

  public showDetailsClick = output<void>();
  public stageClick = output<void>();
  public checkedIconToken: IconToken;
  public actionIconToken: IconToken;

  public ngOnChanges() {
    this.setIconTokens();
  }

  public setIconTokens() {
    this.checkedIconToken = !this.disabled
      ? this.isCurrent
        ? 'colorIconPrimaryDefault'
        : 'colorIconDefault'
      : 'colorIconDisabled';
    this.actionIconToken = !this.disabled ? 'colorIconDefault' : 'colorIconDisabled';
  }
}
